(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4413],{

/***/ 91519:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Home; }
/* harmony export */ });
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89128);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);



function Home(props) {
  var className = props.className,
      styles = props.styles,
      _props$alt = props.alt,
      alt = _props$alt === void 0 ? 'img' : _props$alt,
      src = props.src,
      _props$fitMode = props.fitMode,
      fitMode = _props$fitMode === void 0 ? 'fill-width' : _props$fitMode,
      click = props.click;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_2___default().container), !!className && className),
    style: styles !== null && styles !== void 0 ? styles : {},
    onClick: click,
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
      className: classnames__WEBPACK_IMPORTED_MODULE_0___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_2___default().img), (_index_module_scss__WEBPACK_IMPORTED_MODULE_2___default())[fitMode]),
      alt: alt,
      src: src
    })
  });
}

/***/ }),

/***/ 81833:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ advantage; }
});

// EXTERNAL MODULE: ./node_modules/antd/lib/tabs/style/index.js
var style = __webpack_require__(45059);
// EXTERNAL MODULE: ./node_modules/antd/lib/tabs/index.js
var tabs = __webpack_require__(76825);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/components/tdk/index.tsx + 1 modules
var tdk = __webpack_require__(6071);
// EXTERNAL MODULE: ./src/components/layout/index.tsx + 6 modules
var layout = __webpack_require__(16569);
// EXTERNAL MODULE: ./src/components/product/banner/index.tsx
var banner = __webpack_require__(31016);
// EXTERNAL MODULE: ./src/components/product/banner/multiple.tsx
var multiple = __webpack_require__(12221);
// EXTERNAL MODULE: ./src/components/advantages/index.module.scss
var index_module = __webpack_require__(90531);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./src/components/transition/index.tsx
var transition = __webpack_require__(66335);
// EXTERNAL MODULE: ./src/utils/hooks/useResize.tsx
var useResize = __webpack_require__(94142);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/advantages/index.tsx








var Advantages = function Advantages(prop) {
  var title = prop.title,
      _prop$advantage = prop.advantage,
      advantage = _prop$advantage === void 0 ? [] : _prop$advantage,
      _prop$delay = prop.delay,
      delay = _prop$delay === void 0 ? 0.5 : _prop$delay,
      _prop$className = prop.className,
      className = _prop$className === void 0 ? '' : _prop$className;
  var size = (0,useResize/* default */.Z)();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: classnames_default()((index_module_default()).advantages, className),
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(transition/* default */.Z, {
      delay: delay,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: (index_module_default()).title,
        children: title
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (index_module_default()).items,
      children: advantage.map(function (item, index) {
        var _item$mDesc;

        return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (index_module_default()).item,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (index_module_default()).imgWrapper,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(transition/* default */.Z, {
              delay: delay,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                src: item.icon,
                alt: "",
                className: (index_module_default()).icon
              })
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (index_module_default()).descWrapper,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(transition/* default */.Z, {
              delay: delay,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: (index_module_default()).desc,
                dangerouslySetInnerHTML: {
                  __html: "".concat(size.width < 768 ? (_item$mDesc = item.mDesc) !== null && _item$mDesc !== void 0 ? _item$mDesc : item.desc : item.desc).replace(/\n/g, '<br/>')
                }
              })
            })
          })]
        }, index);
      })
    })]
  });
};

/* harmony default export */ var advantages = (Advantages);
// EXTERNAL MODULE: ./src/components/contact/index.tsx
var contact = __webpack_require__(53784);
// EXTERNAL MODULE: ./src/pages/advantage/index.module.scss
var advantage_index_module = __webpack_require__(57480);
var advantage_index_module_default = /*#__PURE__*/__webpack_require__.n(advantage_index_module);
// EXTERNAL MODULE: ./src/components/image/cdnImage/index.tsx
var cdnImage = __webpack_require__(91519);
;// CONCATENATED MODULE: ./src/pages/advantage/index.tsx




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
















var IMG_PATH = 'https://sdk-source.xylink.com/h5/sdk_doc/static/website/advantage/';
var arrowIcon = [IMG_PATH + 'c7d33ca5b845dae2a15c09acace7b01e8ca6ea0c5d5aae1dbb1781fed4d5df49.png', IMG_PATH + '790fd30bcee8c08029b3666c90609d533f7f4472eee3b0c664d85c21fe07e246.png', IMG_PATH + '07898d27ee2cf768d25eaf370041ff2fda9bf48e33c3678bae7a2e24a2c5032f.png'];
var headerMp4Url = IMG_PATH + '5eabafd0282a29f6f39fb5241927f6f60838e4144f49f18a355a31eacb14eb93.mp4';
var headerGifUrlM = IMG_PATH + 'e27190bb1b7d5498080b715c17f620be34c47173016b7646a839d4d73c514bd5.gif';
var bannerMp4Url = IMG_PATH + '281c18a1953929a627dd0ee7f6c1533aae87c2d3627ad332f69ba10eaa1f7306.mp4';
var bannerGifUrlM = IMG_PATH + 'e6847e9099b71d7a1cee2f00719c507e72c3382817d327e6e8fe38bb3f5741ed.gif';
var advantage_advantages = [[{
  icon: IMG_PATH + '7131df8a6262cad6f51679eca27daa621548334471512d327a70abfbfb17e185.png',
  desc: '自研底层技术\n国产芯片硬件终端\n全面适配信创解决方案'
}, {
  icon: IMG_PATH + 'b94224730c61797521d0e01ca27bd49c91bc9c165e2b598c42bb6d2dff59bb69.png',
  desc: '端到端安全加密\n动态一会一密\n支持国密算法'
}, {
  icon: IMG_PATH + 'ab65fef905bf9f4cb6cf22e28b0fd9cbf119d1225f2d4c80f80c3da69e13fd22.png',
  desc: '权限分级，运管分离\n确保运维安全有序'
}], [{
  icon: IMG_PATH + 'fdb55d42c55c39c073588b8e2305fb40b865212b185dc47dd048e79d6ae7fba1.png',
  desc: '软件定义架构\n全虚拟化平台，与硬件解耦\n可基于任意 IaaS 云底座部署'
}, {
  icon: IMG_PATH + 'f38e7c0326153e0485ad6457a2d8acd7720dd0dc6bcda0463edd47fd829dc552.png',
  desc: '可实现视频会议、直播、点播、监控、\n语音、数据等多种形式融合互通',
  mDesc: '可实现视频会议、直播、点播、\n监控、语音、数据等多种形式\n融合互通'
}, {
  icon: IMG_PATH + '8730666faf90b25ea1dc8a9a42ae5083e0eab4fc3ff06da3c1223561df85141e.png',
  desc: '按需扩展，灵活高效\n无容量上限制约'
}]];
var bannerList = [{
  mUrl: IMG_PATH + '5c0f39f70550e7b75be3dc490acd54acb07b6a8e9bdecbc0577e648dfb1d3275.jpg',
  pcUrl: IMG_PATH + '9f15c58f8028d43afeda122c187791f606016f221b4798d237f6d09e89707293.jpg',
  title: '兼容利旧，终端丰富',
  desc: 'AVC+SVC 双引擎，兼容各主流品牌会议室终端，原有设备充分利旧，实现高效提质升级\n提供形态丰富的各种硬件终端、软件客户端及 SDK 智能设备，可满足各类大中小型会议室以及户外等全场景应用需求',
  mDesc: 'AVC+SVC双引擎，兼容各主流品牌会议室终端，\n原有设备充分利旧，实现高效提质升级\n提供形态丰富的各种硬件终端、软件客户端及 SDK 智\n能设备，可满足各类大中小型会议室以及户外等全场景\n应用需求'
}, {
  mUrl: IMG_PATH + 'b49ca03261987690369de5b207395c8ec0ad603e4b794a40c6b6e3eb33217052.jpg',
  pcUrl: IMG_PATH + 'f66c102e9515a607439511b97d0642e3b8416d0283a00ebc24b6d2352b859038.jpg',
  title: '多网接入，多云融合',
  desc: '支持政务内外网、行业专网、互联网、4G/5G、卫星网等多网络灵活接入\n提供公有云、私有云、混合专有云等多种部署方案，可针对不同行业需求提供定制化服务',
  mDesc: '支持政务内外网、行业专网、互联网、4G/5G、\n卫星网等多网络灵活接入\n提供公有云、私有云、混合专有云等多种部署方案，\n可针对不同行业需求提供定制化服务'
}];
var functions = [{
  title: '人脸识别',
  img: IMG_PATH + 'c780d53347c467f6f8df7a8bdacd9bb78f28ac794d72506c8f0fefd346ef3949.png'
}, {
  title: '自动签到',
  img: IMG_PATH + '05983c680fb64bd41e39113b7421e63045dda491eab0865d5e317e00693bff90.png'
}, {
  title: '电子铭牌',
  img: IMG_PATH + '1f87d6e12a850ecc2d62901ffd9a5008f7b0e2ce20f8616c7ac192b226034755.png'
}, {
  title: '通话字幕',
  img: IMG_PATH + 'subtitle.jpg'
}, {
  title: '自动生成会议纪要',
  img: IMG_PATH + 'a746dfa6526e5dc08aa3a550c015047cab960802a6b032f03145399c919322e2.png'
}];
var bannerDesc = [{
  desc: '全平台高可用架构设计，分布式集群部署\n资源池负载均衡、多活热备、多云多活，故障自动迁移，保证运行稳定不中断',
  mDesc: '全平台高可用架构设计，分布式集群部署\n资源池负载均衡、多活热备、多云多活\n故障自动迁移，保证运行稳定不中断'
}];

var Advantage = function Advantage() {
  var size = (0,useResize/* default */.Z)();

  var _useState = (0,react.useState)(0),
      activeKey = _useState[0],
      setActiveKey = _useState[1];

  var container = (0,react.useRef)(null);
  var stopAct = (0,react.useRef)(false);
  var timerRef = (0,react.useRef)(null);
  var videoRef1 = (0,react.useRef)(null);
  var videoRef2 = (0,react.useRef)(null);

  var clearTimer = function clearTimer() {
    timerRef.current && clearInterval(timerRef.current);
  }; // eslint-disable-next-line react-hooks/exhaustive-deps


  var play = function play() {
    clearTimer();
    if (stopAct.current) return;
    timerRef.current = setInterval(function () {
      setActiveKey(function (activeKey) {
        return (activeKey + 1) % functions.length;
      });
    }, 2000);
  };

  var onScroll = (0,react.useCallback)(function () {
    var clientScreen = document.documentElement.clientHeight;

    if (container.current) {
      var _container$current$ge = container.current.getBoundingClientRect(),
          top = _container$current$ge.top;
      /* 当元素出现在视口当中 */


      if (top < clientScreen) {
        play();
      }
    }
  }, [play]);
  (0,react.useEffect)(function () {
    window.addEventListener('scroll', onScroll, true);
    return function () {
      window.removeEventListener('scroll', onScroll);
      clearTimer();
    };
  }, [onScroll]);
  /* 移动端时 无滚动时 触发动画*/

  (0,react.useEffect)(function () {
    var _container$current;

    if (!((_container$current = container.current) !== null && _container$current !== void 0 && _container$current.scrollTop)) {
      onScroll();
    }
  }, [onScroll]); //自动播放

  (0,react.useEffect)(function () {
    var video1 = videoRef1.current;
    var video2 = videoRef2.current;
    video1 === null || video1 === void 0 ? void 0 : video1.play();
    video2 === null || video2 === void 0 ? void 0 : video2.play();
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(layout/* default */.Z, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(tdk/* default */.Z, {
      pageKey: "advantage"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (advantage_index_module_default()).container,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("video", {
        className: (advantage_index_module_default())["for-pc"],
        autoPlay: true,
        muted: true,
        loop: true,
        src: headerMp4Url,
        "webkit-playsinline": "true",
        playsInline: true,
        "x-webkit-airplay": "true",
        "x5-video-player-type": "h5",
        "x5-video-player-fullscreen": "true",
        "x5-video-ignore-metadata": "true",
        preload: "auto",
        children: "\u60A8\u7684\u6D4F\u89C8\u5668\u4E0D\u652F\u6301video"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (advantage_index_module_default())["for-mobile"],
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(cdnImage/* default */.Z, {
          className: classnames_default()((advantage_index_module_default()).mapImg),
          src: headerGifUrlM,
          alt: "advantage"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (advantage_index_module_default()).advantageWrapper,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(advantages, {
          title: "\u5168\u9762\u81EA\u4E3B\uFF0C\u5B89\u5168\u53EF\u63A7",
          advantage: advantage_advantages[0],
          delay: 0.5,
          className: (advantage_index_module_default()).banner
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
          className: (advantage_index_module_default()).arrowIcon,
          src: arrowIcon[0],
          alt: ""
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(banner/* WrapperBanner */.G, {
        bannerInfo: {
          pcUrl: "".concat(IMG_PATH, "c2878bd48a890785190dbf7425459ffdb36bbe90e1c4f2f4c26f6d711465f3df.jpg"),
          mUrl: "".concat(IMG_PATH, "53da19e04a7893a3034154b0b6a2fb706110ec03112bd96a031035b7580acdba.jpg"),
          classNames: classnames_default()((advantage_index_module_default()).banner1, (advantage_index_module_default()).banner)
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(transition/* default */.Z, {
          delay: 0.5,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            className: (advantage_index_module_default()).title,
            children: "\u9AD8\u53EF\u7528\uFF0C\u7A33\u5B9A\u53EF\u9760"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(transition/* default */.Z, {
          delay: 0.7,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            className: classnames_default()((advantage_index_module_default()).desc),
            dangerouslySetInnerHTML: {
              __html: "".concat(size.width < 768 ? bannerDesc[0].mDesc : bannerDesc[0].desc).replace(/\n/g, '<br>')
            }
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(transition/* default */.Z, {
          delay: 0.9,
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (advantage_index_module_default()).items,
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (advantage_index_module_default()).item,
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: (advantage_index_module_default()).itemTitle,
                children: "\u7A33\u5B9A\u8FD0\u8425\u8D85\u8FC7"
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
                className: (advantage_index_module_default()).itemTotal,
                children: ["70000", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  className: (advantage_index_module_default()).unit,
                  children: "\u5C0F\u65F6"
                })]
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (advantage_index_module_default()).item,
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: (advantage_index_module_default()).itemTitle,
                children: "\u5355\u5BA2\u6237"
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
                className: (advantage_index_module_default()).itemTotal,
                children: ["65000", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  className: (advantage_index_module_default()).unit,
                  children: "\u65B9\u5E76\u53D1"
                })]
              })]
            })]
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(advantages, {
        title: "\u8D85\u878D\u5408\uFF0C\u9002\u7528\u6027\u5F3A",
        advantage: advantage_advantages[1],
        delay: 0.5,
        className: (advantage_index_module_default()).banner
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((advantage_index_module_default()).technology, (advantage_index_module_default()).banner),
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("video", {
          className: (advantage_index_module_default())["for-pc"],
          autoPlay: true,
          muted: true,
          loop: true,
          src: bannerMp4Url,
          "webkit-playsinline": "true",
          playsInline: true,
          "x-webkit-airplay": "true",
          "x5-video-player-type": "h5",
          "x5-video-player-fullscreen": "true",
          "x5-video-ignore-metadata": "true",
          preload: "auto",
          children: "\u60A8\u7684\u6D4F\u89C8\u5668\u4E0D\u652F\u6301video"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (advantage_index_module_default())["for-mobile"],
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(cdnImage/* default */.Z, {
            className: classnames_default()((advantage_index_module_default()).mapImg),
            src: bannerGifUrlM,
            alt: "advantage"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (advantage_index_module_default()).content,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(transition/* default */.Z, {
            delay: 0.5,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              className: (advantage_index_module_default()).title,
              children: "\u6280\u672F\u9886\u5148\uFF0C\u7B97\u6CD5\u9AD8\u6548"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(transition/* default */.Z, {
            delay: 0.8,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              className: classnames_default()((advantage_index_module_default()).desc, 'for-pc'),
              children: "\u5927\u89C4\u6A21\u6210\u719F\u5E94\u7528 SVC \u67D4\u6027\u7F16\u89E3\u7801\u7B97\u6CD5"
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
              className: classnames_default()((advantage_index_module_default()).desc, 'for-mobile'),
              children: ["\u5927\u89C4\u6A21\u6210\u719F\u5E94\u7528 SVC \u67D4\u6027\u7F16\u89E3\u7801\u7B97\u6CD5", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "\u667A\u80FD\u8DEF\u7531\u67B6\u6784\uFF0C\u76F8\u6BD4\u4F20\u7EDF MCU\uFF0C"]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
              className: classnames_default()((advantage_index_module_default()).desc, 'for-pc'),
              children: ["\u667A\u80FD\u8DEF\u7531\u67B6\u6784\uFF0C\u76F8\u6BD4\u4F20\u7EDF MCU\uFF0C\u786C\u4EF6\u6548\u7387\u63D0\u5347", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                className: (advantage_index_module_default()).number,
                children: "50"
              }), "\u500D\uFF0C\u5EF6\u65F6\u964D\u4F4E", /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                className: (advantage_index_module_default()).number,
                children: ["80 ", /*#__PURE__*/(0,jsx_runtime.jsx)("sub", {
                  children: "%"
                })]
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
              className: classnames_default()((advantage_index_module_default()).desc, 'for-mobile'),
              children: ["\u786C\u4EF6\u6548\u7387\u63D0\u5347", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                className: (advantage_index_module_default()).number,
                children: "50"
              }), "\u500D\uFF0C\u5EF6\u65F6\u964D\u4F4E", /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                className: (advantage_index_module_default()).number,
                children: ["80 ", /*#__PURE__*/(0,jsx_runtime.jsx)("sub", {
                  children: "%"
                })]
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              className: classnames_default()((advantage_index_module_default()).desc, 'for-pc'),
              children: "\u65E0\u9700\u4E13\u7F51\uFF0C\u5177\u6709\u8D85\u5F3A\u6297\u4E22\u5305\u80FD\u529B\uFF0C\u5B9E\u73B0 30% \u4E22\u5305\u4E0D\u82B1\u5C4F\uFF0C50% \u4E22\u5305\u58F0\u97F3\u6E05\u695A\u8FDE\u8D2F"
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
              className: classnames_default()((advantage_index_module_default()).desc, 'for-mobile'),
              children: ["\u65E0\u9700\u4E13\u7F51\uFF0C\u5177\u6709\u8D85\u5F3A\u6297\u4E22\u5305\u80FD\u529B\uFF0C", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "\u5B9E\u73B0 30% \u4E22\u5305\u4E0D\u82B1\u5C4F\uFF0C50% \u4E22\u5305\u58F0\u97F3\u6E05\u695A\u8FDE\u8D2F"]
            })]
          })]
        })]
      }), bannerList.map(function (item, index) {
        return /*#__PURE__*/(0,react.createElement)(multiple/* default */.Z, _objectSpread(_objectSpread({
          animate: 'fadeIn',
          delay: 0.5
        }, item), {}, {
          key: item.title,
          type: 0,
          className: classnames_default()((advantage_index_module_default()).banner, (advantage_index_module_default()).banner2, index === 1 && (advantage_index_module_default()).banner3)
        }));
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((advantage_index_module_default()).banner, (advantage_index_module_default()).banner6),
        ref: container,
        style: {
          backgroundImage: "url(".concat(size.width < 768 ? '' : arrowIcon[2], ")")
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(transition/* default */.Z, {
          delay: 0.5,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            className: (advantage_index_module_default()).title,
            children: "\u6613\u7BA1\u6613\u7528\uFF0CAI \u8D4B\u80FD"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(transition/* default */.Z, {
          delay: 0.5,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            className: (advantage_index_module_default()).desc,
            children: "\u7EDF\u4E00\u5165\u53E3\u7BA1\u7406\uFF0C\u4E30\u5BCC\u7684\u4F1A\u63A7\u529F\u80FD\uFF0C\u8BA9\u7BA1\u63A7\u66F4\u9AD8\u6548"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (advantage_index_module_default()).items,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (advantage_index_module_default()).titleWrapper,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(transition/* default */.Z, {
              delay: 0,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: (advantage_index_module_default()).littleTitle,
                children: "\u4E30\u5BCC\u7684 AI \u667A\u80FD\u5E94\u7528"
              })
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(tabs/* default */.Z, {
            tabPosition: size.width < 768 ? 'top' : 'left',
            animated: size.width < 768 ? true : false,
            className: (advantage_index_module_default()).test,
            activeKey: activeKey.toString(),
            onTabClick: function onTabClick(activeKey) {
              stopAct.current = true;
              setActiveKey(Number(activeKey));
              clearTimer();
            },
            children: functions.map(function (item, index) {
              return /*#__PURE__*/(0,jsx_runtime.jsx)(tabs/* default.TabPane */.Z.TabPane, {
                tab: item.title,
                className: (advantage_index_module_default()).item,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                  src: item.img,
                  alt: "",
                  className: (advantage_index_module_default()).img
                })
              }, index);
            })
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
          className: classnames_default()((advantage_index_module_default()).arrowIcon, 'for-mobile'),
          src: arrowIcon[1],
          alt: ""
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (advantage_index_module_default()).banner5,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(multiple/* default */.Z, {
          type: 2,
          mUrl: "".concat(IMG_PATH, "b6dcca7ae95845559777a8fee4769f75df093a1b4775e6f1a7c118ab8131ac25.jpg"),
          pcUrl: "".concat(IMG_PATH, "ed0580099b29ba99caa4aa90629bfcfeca3f223853fc5f33d6e4f98f777d4fa4.jpg"),
          title: '开放赋能，集成简便',
          desc: "\u5168\u9762\u5F00\u653E API/SDK \u80FD\u529B\uFF0C\u4E3A\u4E1A\u52A1\u8D4B\u80FD\u4E0E\u573A\u666F\u521B\u65B0\u63D0\u4F9B\u5F3A\u5927\u7684\u97F3\u89C6\u9891\u5E95\u5EA7\u652F\u6491\n\u8F7B\u4EE3\u7801\u5F00\u53D1\uFF0C\u65B9\u4FBF\u5BF9\u63A5\u4E0E\u8C03\u8BD5\uFF0C\u53EF\u6709\u6548\u63D0\u5347\u5F00\u53D1\u6548\u7387\uFF0C\u786E\u4FDD\u5FEB\u901F\u4E0A\u7EBF",
          mDesc: "\u5168\u9762\u5F00\u653E API/SDK \u80FD\u529B\uFF0C\n\u4E3A\u4E1A\u52A1\u8D4B\u80FD\u4E0E\u573A\u666F\u521B\u65B0\u63D0\u4F9B\u5F3A\u5927\u7684\u97F3\u89C6\u9891\u5E95\u5EA7\u652F\u6491\n\u8F7B\u4EE3\u7801\u5F00\u53D1\uFF0C\u65B9\u4FBF\u5BF9\u63A5\u4E0E\u8C03\u8BD5\uFF0C\n\u53EF\u6709\u6548\u63D0\u5347\u5F00\u53D1\u6548\u7387\uFF0C\u786E\u4FDD\u5FEB\u901F\u4E0A\u7EBF",
          className: classnames_default()((advantage_index_module_default()).banner, (advantage_index_module_default()).banner2, (advantage_index_module_default()).banner4),
          delay: 0.5,
          animate: 'fadeIn'
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(contact/* default */.Z, {
          className: (advantage_index_module_default()).contact,
          btnType: 'newBtn'
        })]
      })]
    })]
  });
};

/* harmony default export */ var advantage = (Advantage);

/***/ }),

/***/ 77634:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/advantage",
      function () {
        return __webpack_require__(81833);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 90531:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"border__px":"advantages_border__px__lmIIc","border__px-before":"advantages_border__px-before__X_yWS","border__px-before1":"advantages_border__px-before1__BlRx5","border-children1":"advantages_border-children1__ualfG","border-children2":"advantages_border-children2__5m40w","for-mobile":"advantages_for-mobile__9r8R6","for-pc":"advantages_for-pc__mqhsh","advantages":"advantages_advantages__3bO9K","title":"advantages_title__Kh0hY","items":"advantages_items__nRj3U","item":"advantages_item__2R4EN","imgWrapper":"advantages_imgWrapper__emeQB","icon":"advantages_icon__632Ld","descWrapper":"advantages_descWrapper__UrIQd","desc":"advantages_desc__OYyie"};

/***/ }),

/***/ 89128:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"cdnImage_container__YAbPG","fill-height":"cdnImage_fill-height__hIziF"};

/***/ }),

/***/ 57480:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"border__px":"advantage_border__px__IBRGa","border__px-before":"advantage_border__px-before__T2k4B","border__px-before1":"advantage_border__px-before1__PkRcM","border-children1":"advantage_border-children1__8wVZM","border-children2":"advantage_border-children2__Bwafb","for-mobile":"advantage_for-mobile__Ae3Zi","for-pc":"advantage_for-pc__8Msvg","container":"advantage_container__x9nrX","banner":"advantage_banner__WkDUN","title":"advantage_title__9b68q","desc":"advantage_desc__vmF6B","advantageWrapper":"advantage_advantageWrapper__lgByR","arrowIcon":"advantage_arrowIcon__63qmE","banner1":"advantage_banner1__kWv8d","items":"advantage_items__FGAJa","item":"advantage_item__9tdxU","itemTitle":"advantage_itemTitle__HMeLV","itemTotal":"advantage_itemTotal__EYRXw","unit":"advantage_unit__rLZwn","technology":"advantage_technology__0afMa","content":"advantage_content__tL5Rt","number":"advantage_number__f1Px4","banner2":"advantage_banner2__FAPO_","banner3":"advantage_banner3__fRc2A","banner4":"advantage_banner4__eI88I","banner5":"advantage_banner5__v03Os","contact":"advantage_contact__4Fdd8","banner6":"advantage_banner6__scUrT","titleWrapper":"advantage_titleWrapper__qp0lP","littleTitle":"advantage_littleTitle__gTmqE","img":"advantage_img___Q6yP"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1747,4662,6797,9243,4488,9774,2888,179], function() { return __webpack_exec__(77634); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);